module.exports = __webpack_public_path__ + "img/swiper_06.59d2346f.jpg";